import React, { useEffect, useState } from "react";
import "./FAQ.css";

const FAQs = () => {
  const [faqs, setFaqs] = useState([]);
  const [showAll, setShowAll] = useState(false);

  const SHEET_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vR-NvipoG_RtiURVnuEqram-ouqCQyJKVC9UYLrtRnvQaZJP9Rkje7CAJ1OC_EJ1pXIeBsBqqoRWrzk/pub?output=csv"; // replace

  useEffect(() => {
    fetch(SHEET_URL)
      .then((res) => res.text())
      .then((text) => {
        const rows = text.split("\n").slice(1); // Skip header
        const parsed = rows.map((line) => {
          const [question, answer] = line.split(",");
          return { question, answer };
        });
        setFaqs(parsed);
      });
  }, []);

  const displayedFaqs = showAll ? faqs : faqs.slice(0, 5);

  return (
    <section className="faq-section">
      <h2 className="faq-heading">Frequently Asked Questions</h2>
      <div className="faq-list">
        {displayedFaqs.map((faq, idx) => (
          <div className="faq-card" key={idx}>
            <h4>{faq.question}</h4>
            <p>{faq.answer}</p>
          </div>
        ))}
      </div>
      {faqs.length > 5 && (
        <button className="read-more-btn" onClick={() => setShowAll(!showAll)}>
          {showAll ? "Show Less" : "Read More"}
        </button>
      )}
    </section>
  );
};

export default FAQs;
